import React, { useEffect, useState } from "react";
import { Radio } from "antd";
import { getIconUrl } from "../../../../../../services/asset";
import { NotificationFrequency } from "../../../../../../models/enums";

import styles from "./notificationSelector.scss";

interface NotificationSelectorProps {
  hasIcon?: boolean;
  value?: number;
  className?: string;
  radioContainerClassName?: string;
  onChange?: (value: number) => void;
}

const NotificationSelector = (props: NotificationSelectorProps) => {
  const { hasIcon, radioContainerClassName, className, value } = props;
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    if (value && value != selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleChange = e => {
    const { onChange } = props;

    setSelectedValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.notify}>
        {hasIcon ? (
          <img
            alt={"Obavijest"}
            src={getIconUrl("notify.svg")}
          />
        ) : null}
        <span className={styles.titleText}>
          {"Razdoblje obavijesti"}
        </span>
      </div>
      <div
        className={`tag-button-group uppercase ${styles.radioContainer} ${radioContainerClassName}`}
      >
        <Radio.Group onChange={handleChange} value={selectedValue}>
          {NotificationFrequency.map((nf, index) => (
            <Radio.Button
              value={nf.value}
              key={index /* eslint-disable-line */}
            >
              {nf.name}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
    </div>
  );
};

NotificationSelector.defaultProps = {
  onChange: () => null,
  hasIcon: false,
  radioContainerClassName: "",
  className: ""
};

export default NotificationSelector;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchWeb/SavedSearchItem/NotificationSelector/index.tsx